var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal-action-" + _vm.action,
          attrs: {
            id: "modal-action-" + _vm.action,
            title: _vm.title + " documento",
            "no-close-on-backdrop": "",
            "ok-title": _vm.title,
            "cancel-title": "Cancelar",
            size: "lg"
          },
          on: { ok: _vm.commitAction, cancel: _vm.cancelProcess }
        },
        [
          _c("div", { staticClass: "-mt-2" }, [
            _c(
              "form",
              {
                staticClass: "d-flex justify-content-between mt-4",
                attrs: {
                  autocomplete: "off",
                  "data-vv-scope": "sign-document"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "vs-select",
                  {
                    staticClass: "w-50 mb-3",
                    attrs: {
                      autocomplete: "",
                      label: "Seleccione tipo de Firma"
                    },
                    model: {
                      value: _vm.signType,
                      callback: function($$v) {
                        _vm.signType = $$v
                      },
                      expression: "signType"
                    }
                  },
                  _vm._l(_vm.userSignConfiguration.userSigns, function(firma) {
                    return _c("vs-select-item", {
                      key: firma.id,
                      attrs: {
                        value: firma,
                        text: _vm.providerName(firma.proveedor)
                      }
                    })
                  }),
                  1
                ),
                _vm.signerProviderConfig.otp
                  ? _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: " ml-2 w-50",
                      attrs: {
                        autocomplete: "off",
                        label: "Código OTP",
                        maxlength: "6",
                        name: "otp",
                        danger: _vm.errors.has("sign-document.otp"),
                        "danger-text": _vm.errors.first("sign-document.otp")
                      },
                      model: {
                        value: _vm.otpCode,
                        callback: function($$v) {
                          _vm.otpCode = $$v
                        },
                        expression: "otpCode"
                      }
                    })
                  : _vm._e(),
                _vm.signerProviderConfig.password
                  ? _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      staticClass: "col-12",
                      attrs: {
                        autocomplete: "off",
                        type: "password",
                        label: "Contraseña de certificado",
                        name: "certificatePassword",
                        danger: _vm.errors.has(
                          "sign-document.certificatePassword"
                        ),
                        "danger-text": _vm.errors.first(
                          "sign-document.certificatePassword"
                        )
                      },
                      model: {
                        value: _vm.certificatePassword,
                        callback: function($$v) {
                          _vm.certificatePassword = $$v
                        },
                        expression: "certificatePassword"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "modal-action-" + _vm.action + "-agile",
          attrs: {
            id: "modal-action-" + _vm.action + "-agile",
            title: _vm.title + " documento",
            "ok-title": _vm.title,
            "no-close-on-backdrop": "",
            "cancel-title": "Cancelar",
            size: "sm"
          },
          on: { ok: _vm.commitActionAgile, cancel: _vm.cancelProcess }
        },
        [
          _c(
            "form",
            {
              staticClass: "d-flex justify-content-center",
              attrs: {
                autocomplete: "off",
                "data-vv-scope": "sign-document-agile"
              },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", [
                      _vm._v(
                        " Se ha enviado un código de seguridad a tu dirección de correo electrónico. Por favor, revisa tu bandeja de entrada. El correo contendrá un código de seguridad único que deberás ingresar para completar el proceso de registro. "
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        " Si no encuentras el correo electrónico en tu bandeja de entrada, te recomendamos verificar la carpeta de correo no deseado (spam). "
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        " Recuerda que el código de seguridad es personal y confidencial. No lo compartas con nadie y asegúrate de ingresarlo correctamente. "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group d-flex justify-content-center"
                      },
                      [
                        _c("OtpInput", {
                          on: { complete: _vm.commitActionAgile },
                          model: {
                            value: _vm.otpCode,
                            callback: function($$v) {
                              _vm.otpCode = $$v
                            },
                            expression: "otpCode"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }